import serviceRequest from "utils/request";

const baseUrl = "/api/roletofunction";

export const getFunctionList = () => {
	return serviceRequest({
		url: `${baseUrl}/list`,
		method: "get",
	});
};

export const getRoletofunctionRole = () => {
	return serviceRequest({
		url: `${baseUrl}/role`,
		method: "get",
	});
};

export const geFunctionDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const updateFunction = (data) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data,
	});
};
